/**
 * replace text with map
 *
 * @param {String} str //original string,
 * str eg."Once you make the following changes on Step ${changeStep}. The information for step ${clearedStep} will be cleared. "
 * @param {Object} replaceMap //replaceMap
 * replaceMap eg.{changeStep: 1,clearedStep: 2}
 * @return {String} output eg. "Once you make the following changes on Step 1. The information for step 2 will be cleared. "
 */
export default (str: string, replaceMap: object) => {
  const wrappedMap = {};
  Object.keys(replaceMap).forEach((item) => {
    (wrappedMap as any)['${' + item + '}'] = (replaceMap as any)[item];
  });
  let reStr =
    '(' +
    Object.keys(replaceMap)
      .map((it) => '\\${' + it + '}')
      .join('|') +
    ')';
  let re = new RegExp(reStr, 'g');
  return str.replace(re, (it) => (wrappedMap as any)[it]);
};
